import 'es6-promise/auto';
import 'relapp-polyfills';

import Vue from 'vue';
import VueScrollTo from 'vue-scrollto';
import { Way2Forms } from 'relapp-way2forms';
import { Auth } from 'relapp-auth';
import vSelect from 'vue-select';
import VueGlobalVariable from 'vue-global-var';
import * as tabulatorConfig from '@/config/tabulator.json';

import { getDateFromW3c, setLocale, toDecimal, toEuro } from 'relapp-helpers';

import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

import Lang from 'lang.js';
import messages from './lang/messages.js';

import { CustomerRouterLink } from 'relapp-customer-switch';

const lang = new Lang({
    messages: messages,
    locale: 'nl'
});

/**
 * Intitialize the moment locale.
 */
setLocale('nl');

/**
 * A wrapper around the lang.get() function, so we can be constant between the front-end and the back-end code.
 *
 * @param {string} string
 * @param {array} args
 *
 * @return {string}
 */
window.trans = function(string, args) {
    return lang.get(string, args);
};

/**
 * A wrapper around the Lang.choice() function, so we can be consistent between the front-end and the back-end code.
 *
 * @param {string} string
 * @param {number} amount
 * @param {object} args
 *
 * @return {string}
 */
window.trans_choice = function(string, amount, args) {
    return lang.choice(string, amount, args);
};

window.locale = lang.getLocale();

/**
 * Bind the global helper functions to Vue for use inside the template parts.
 */
/* eslint-disable camelcase */
Vue.prototype.trans = window.trans;
Vue.prototype.trans_choice = window.trans_choice;
/* eslint-enable camelcase */

/**
 * Plugins
 */
Vue.use(VueScrollTo);
Vue.use(Way2Forms);
Vue.use(Auth);
Vue.component('v-select', vSelect);
Vue.component('customer-router-link', CustomerRouterLink);

Vue.use(VueGlobalVariable, {
    globals: {
        tabulatorConfig
    }
});

/**
 * Custom Vue filters
 */
Vue.filter('toEuro', toEuro);
Vue.filter('toDecimal', toDecimal);
Vue.filter('date', getDateFromW3c);

/**
 * Check if the .env file has a Sentry public dsn key and if the current environment is live.
 * When both are true Initialize Sentry
 */
if (process.env.VUE_APP_SENTRY_DSN) {
    Sentry.init({
        dsn: process.env.VUE_APP_SENTRY_DSN,
        environment: process.env.VUE_APP_SENTRY_ENVIRONMENT,
        debug: process.env.VUE_APP_SENTRY_DEBUG,
        integrations: [
            new Integrations.Vue({
                Vue,
                attachProps: true
            })
        ]
    });
}
